import { Field, useFormikContext } from "formik";
import { X } from "react-feather";
import { ErrorMessage } from "../../Form/ErrorMessage/ErrorMessage";
import { ImageUpload } from "../../Form/ImageUpload/ImageUpload";
import { Input } from "../../Form/Input/Input";
import { TextArea } from "../../Form/TextArea/TextArea";
import { Button } from "../../UI/Button/Button";
import { ShadowBox } from "../../UI/ShadowBox/ShadowBox";
import { Bullets } from "../Bullets/Bullets";
import styles from "./Step.module.scss";

export const Step = ({ slug, index, onRemove }) => {
  const { initialValues, setFieldValue } = useFormikContext();

  return (
    <ShadowBox>
      <div className={styles.imageContainer}>
        <ImageUpload
          initialImage={initialValues.image}
          onChange={(imageFile) => {
            setFieldValue(`${slug}.image`, { file: imageFile });
          }}
        />
        {index > 0 && (
          <Button className={styles.removeStepButton} onClick={onRemove}>
            <X />
            <span>Remove step</span>
          </Button>
        )}
      </div>
      <div className={styles.content}>
        <ErrorMessage name={`steps[${index}].image.file`} />

        <div className={styles.titleContainer}>
          <h2 className={styles.number}>{index + 1}</h2>
          <Field name={`${slug}.title`} as={Input} placeholder="Type a title here..." />
        </div>
        <ErrorMessage name={`steps[${index}].title`} />

        <Field name={`${slug}.description`} as={TextArea} placeholder="Type a description here..." />
        <ErrorMessage name={`steps[${index}].description`} />

        <Bullets slug={`${slug}.bullets`} />
      </div>
    </ShadowBox>
  );
};
